import { Component, OnInit, Inject } from '@angular/core';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { PonchoUIModule } from '@poncho/ui';
import { NgClass } from '@angular/common';

@Component({
    selector: 'repeat-customization-bottom-sheet',
    templateUrl: './repeat-customization-bottom-sheet.component.html',
    styleUrls: ['./repeat-customization-bottom-sheet.component.scss'],
    standalone: true,
    imports: [NgClass, PonchoUIModule]
})
export class RepeatCustomizationBottomSheetComponent implements OnInit {
    constructor(
        private _bottomSheetRef: MatBottomSheetRef<RepeatCustomizationBottomSheetComponent>,
        @Inject(MAT_BOTTOM_SHEET_DATA) public data
    ) {}

    product: any;

    ngOnInit(): void {
        this.product = this.data.menuData.products[this.data.product_id];
    }

    close() {
        this._bottomSheetRef.dismiss();
    }

    submit(type) {
        this._bottomSheetRef.dismiss(type);
    }

    getObjectKeys(description) {
        return Object.keys(description);
    }

    isObject(obj) {
        return typeof obj === 'object' && obj !== null;
    }
}
